<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Update SD Sub Status</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />

      <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>SD Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
             <v-select
                    label="name"
                    name="sd_status"
                    :options="sd_statuses"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="sd_sub_statusDescription.sd_status"
                  />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('sd_status')"
              >{{ errors.first("sd_status") }}</span
            >
          </div>

        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="name"
                v-model="sd_sub_statusDescription.sub_status"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                name="description"
                class="w-full"
                v-model="sd_sub_statusDescription.description"
                data-vv-as="Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>

             <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Level:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
               <vs-radio v-model="sd_sub_statusDescription.level" vs-value="account" class="mr-4" vs-name="layout-type-vertical">Account</vs-radio>
                <vs-radio v-model="sd_sub_statusDescription.level" vs-value="contact" class="mr-4" vs-name="layout-type-horizontal">Contact</vs-radio>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('level')"
              >{{ errors.first("level") }}</span
            >
          </div>


            <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              <div
  v-for="role in roles"
  :key="role.id || role.role"
>
  <input
  class="p-2 m-3"
    type="checkbox"
    v-validate="'required'"
    data-vv-as="Role"
    name="roles[]"
    v-model="sd_sub_statusDescription.role"
    :value="role.role"
  />
  {{ role.role }}
</div>


         


            </div>
               <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('roles[]')"
              >{{ errors.first("roles[]") }}</span
            >
        
          </div>
   

          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="updateForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <!-- <DataGrid :context="'SDSubStatus'" 
            ref="sd_sub_status"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid> -->
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleSDSubStatusManagement from "@/store/sd-sub-status-management/moduleSDSubStatusManagement.js";
import moduleSDStatusManagement from "@/store/sd-status-management/moduleSDStatusManagement.js";
import moduleRoleManagement from "@/store/role-management/moduleRoleManagement.js";import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
            sd_statuses: [],

            roles : [],
       please_choose_type: null,
      selected_sales_developer: [],
      user_role: null,
      sd_sub_statusDescription: [],
      sd_sub_status_id: null,
      columnDefs: [
        {
          headerName: "SDSubStatus",
          flex: 1,
          field: "status",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          flex: 1,
          field: "description",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
 
      ],
      dataSource: {},
      records: [],
      selected: [],
      allSDSubStatus: [],
      abilities: null,
      sd_sub_statusDescription: {
          sd_status: null,
          sub_status: null,
          description: null,
          level: null,
          role: []
       
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleSDSubStatusManagement,
    moduleSDStatusManagement,
    moduleRoleManagement
      },
  created() {
    var self = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });


  
        if (!moduleSDStatusManagement.isRegistered) {
      this.$store.registerModule("SDStatusManagement", moduleSDStatusManagement);
      moduleSDStatusManagement.isRegistered = true;
    }


    if (!moduleSDSubStatusManagement.isRegistered) {
      this.$store.registerModule("SDSubStatusManagement", moduleSDSubStatusManagement);
      moduleSDSubStatusManagement.isRegistered = true;
    }

       if (!moduleRoleManagement.isRegistered) {
      this.$store.registerModule(
        "rolesManagement",
        moduleRoleManagement
      );
      moduleRoleManagement.isRegistered = true;
    }
  },
  mounted() {
    this.sd_sub_status_id = this.$route.params.substatusId;
    this.fetchSDSubStatus();

     this.getAllSDStatuses();
    this.fetchAllRoles();
  },
  watch: {},
  methods: {
        fetchAllRoles() {
      this.$store
        .dispatch(
          "rolesManagement/fetchRoles"
        )
        .then(res => {
          console.log("Roles", res);
          this.roles =
            moduleRoleManagement.state.roles;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getAllSDStatuses() {
      this.$store
        .dispatch("SDStatusManagement/getAllSDStatuses")
        .then(res => {
          if (res.data != null){
            this.sd_statuses = JSON.parse(res.data);
            console.log(this.sd_statuses);
          }
         
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {

          self.$store
            .dispatch("SDSubStatusManagement/getAllSDSubStatus", params.request)
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.sd_sub_status.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.sd_sub_status.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.push({ path: "/sd_sub_statuses" });
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateSDSubStatus();
        }
      });
    },
    updateSDSubStatus() {
      this.$store
        .dispatch("SDSubStatusManagement/updateSDSubStatus", this.sd_sub_statusDescription)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "SDSubStatus Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "SDSubStatus Updated",
              text: "The sd_sub_status was updated successfully"
            });
            this.$router.push({ path: "/sd_sub_statuses" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchSDSubStatus() {
      let self = this;
      this.$store
        .dispatch("SDSubStatusManagement/fetchSDSubStatus", self.sd_sub_status_id)
        .then(res => {
          let result = JSON.parse(res.data);

          self.sd_sub_statusDescription = result[0];

  

        console.log("DES" , self.selected_roles);


        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
